/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The status of the job.
 */
export type BackgroundJobStatus =
  (typeof BackgroundJobStatus)[keyof typeof BackgroundJobStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackgroundJobStatus = {
  OPEN: "OPEN",
  SCHEDULED: "SCHEDULED",
  ENQUEUED: "ENQUEUED",
  PROCESSING: "PROCESSING",
  FINISHED: "FINISHED",
  FAILED: "FAILED",
} as const;
